__turbopack_context__.v({
  "colorId--abzan": "u3wUQG_colorId--abzan",
  "colorId--azorius": "u3wUQG_colorId--azorius",
  "colorId--bant": "u3wUQG_colorId--bant",
  "colorId--boros": "u3wUQG_colorId--boros",
  "colorId--dimir": "u3wUQG_colorId--dimir",
  "colorId--dune-brood": "u3wUQG_colorId--dune-brood",
  "colorId--esper": "u3wUQG_colorId--esper",
  "colorId--five-color": "u3wUQG_colorId--five-color",
  "colorId--glint-eye": "u3wUQG_colorId--glint-eye",
  "colorId--golgari": "u3wUQG_colorId--golgari",
  "colorId--grixis": "u3wUQG_colorId--grixis",
  "colorId--gruul": "u3wUQG_colorId--gruul",
  "colorId--ink-treader": "u3wUQG_colorId--ink-treader",
  "colorId--izzet": "u3wUQG_colorId--izzet",
  "colorId--jeskai": "u3wUQG_colorId--jeskai",
  "colorId--jund": "u3wUQG_colorId--jund",
  "colorId--mardu": "u3wUQG_colorId--mardu",
  "colorId--mono-black": "u3wUQG_colorId--mono-black",
  "colorId--mono-blue": "u3wUQG_colorId--mono-blue",
  "colorId--mono-green": "u3wUQG_colorId--mono-green",
  "colorId--mono-red": "u3wUQG_colorId--mono-red",
  "colorId--mono-white": "u3wUQG_colorId--mono-white",
  "colorId--naya": "u3wUQG_colorId--naya",
  "colorId--orzhov": "u3wUQG_colorId--orzhov",
  "colorId--rakdos": "u3wUQG_colorId--rakdos",
  "colorId--selesnya": "u3wUQG_colorId--selesnya",
  "colorId--simic": "u3wUQG_colorId--simic",
  "colorId--sultai": "u3wUQG_colorId--sultai",
  "colorId--temur": "u3wUQG_colorId--temur",
  "colorId--witch-maw": "u3wUQG_colorId--witch-maw",
  "colorId--yore-tiller": "u3wUQG_colorId--yore-tiller",
  "container": "u3wUQG_container",
  "empty": "u3wUQG_empty",
  "square": "u3wUQG_square",
  "vertical": "u3wUQG_vertical",
});
